import { render, staticRenderFns } from "./ConfiGured.vue?vue&type=template&id=900c2c1e&scoped=true"
import script from "./ConfiGured.vue?vue&type=script&lang=js"
export * from "./ConfiGured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900c2c1e",
  null
  
)

export default component.exports